import axios from "axios";
export const SignInAPI = {
  data: () => ({}),
  methods: {
    async SignInAPIMethod(user_email_id, password) {
      try {
        var data = JSON.stringify({
          command: "userSignIn",
          user_email_id: user_email_id,
          password: password,
        });
        var config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://cmjo10iqb9.execute-api.ap-south-1.amazonaws.com/dev/user_auth/signin",
          headers: {},
          data: data,
        };

        let result = await axios(config);
        return result;
      } catch (error) {
        return {
          status: error.response.status,
          statusText: "FAILURE",
          error: error.response.data.Model,
        };
      }
    },
  },
};
